import { getOrderTiming, parsePrepMinutes, parseReceivedTime } from "./orderTiming";

export function filterSortKitchenOrders(orders = [], { sort = "due", filter = "all", now = Date.now() } = {}) {
  const rows = orders.map((order, index) => {
    const created = parseReceivedTime(order.created);
    const prep = parsePrepMinutes(order.prepTime);
    return {
      order, index, created, prep,
      deadline: created != null && prep != null ? created + prep * 60000 : null,
      tone: getOrderTiming(order, now).tone,
    };
  }).filter((row) => filter === "all" ||
    (filter === "due" && row.tone === "orange") ||
    (filter === "overdue" && row.tone === "red"));
  const compare = (a, b, descending = false) => {
    if (a == null || !Number.isFinite(a)) return b == null || !Number.isFinite(b) ? 0 : 1;
    if (b == null || !Number.isFinite(b)) return -1;
    return descending ? b - a : a - b;
  };
  return rows.sort((a, b) => {
    const primary = sort === "newest" ? compare(a.created, b.created, true)
      : sort === "oldest" ? compare(a.created, b.created)
      : sort === "quickest" ? compare(a.prep, b.prep)
      : compare(a.deadline, b.deadline);
    return primary || compare(a.created, b.created) || a.index - b.index;
  }).map((row) => row.order);
}
